const features = [
    { icon: '/icons/oneaccount.svg', text: 'One Account. Every Legal Solution' },
    { icon: '/icons/smartconnect.svg', text: 'Smart Contract & Obligation Tracking' },
    { icon: '/icons/aipowered.svg', text: 'AI-Powered Legal Intelligence' },
    { icon: '/icons/courtconnected.svg', text: 'Court-Connected Dispute Resolution' },
    { icon: '/icons/connectwithreallawyer.svg', text: 'Connect with Real Lawyers', italic: '– On Demand' },
    { icon: '/icons/secured.svg', text: 'Secure & Trusted Legal Infrastructure' },
];

export default function PodusAiFeatures() {
    return (
        <section className="relative z-10">
            <div className="overflow-hidden bg-[#F6F6F6] py-5 sm:py-6">
                <div className="marquee-track flex w-max items-center gap-6 whitespace-nowrap sm:gap-8">
                    {Array.from({ length: 2 }).map((_, copy) => (
                        <div key={copy} className="flex items-center gap-6 sm:gap-8">
                            {features.map((f) => (
                                <div
                                    key={`${copy}-${f.text}`}
                                    className="flex items-center gap-3 px-6 py-4 sm:gap-4 sm:px-8 sm:py-5"
                                >
                                    <img
                                        src={f.icon}
                                        alt=""
                                        className="h-7 w-7 shrink-0 object-contain opacity-50 sm:h-8 sm:w-8"
                                    />
                                    <span className="text-base font-medium tracking-tight text-[#B0B0B0] sm:text-lg lg:text-xl">
                                        {f.text}
                                        {f.italic && <em className="ml-1">{f.italic}</em>}
                                    </span>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
